// @flow
const PREFIX_DEVICES = `hive/devices/`;
const PREFIX_ZONE = `hive/zone/`;

export const LOAD_DEVICES = `${PREFIX_DEVICES}LOAD`;
export const LOAD_INSTALL_OPTIONS = `${PREFIX_DEVICES}LOAD_INSTALL_OPTIONS`;
export const LOAD_MANAGE_DEVICES = `${PREFIX_DEVICES}LOAD_MANAGE_DEVICES`;
export const RECEIVE_DEVICES = `${PREFIX_DEVICES}RECEIVE_DEVICES`;
export const REMOVED_DEVICE = `${PREFIX_DEVICES}removed`;
export const REMOVED_ZONE = `${PREFIX_ZONE}removed`;
export const REMOVE_DEVICE = `${PREFIX_DEVICES}remove`;
export const REMOVE_DEVICE_ERROR = `${PREFIX_DEVICES}remove_error`;
export const REMOVE_ZONE = `${PREFIX_ZONE}remove`;
export const RENAMED_DEVICE = `${PREFIX_DEVICES}renamed`;
export const RENAMED_ZONE = `${PREFIX_ZONE}renamed`;
export const RENAME_DEVICE = `${PREFIX_DEVICES}rename`;
export const RENAME_HUB_DEVICES = `${PREFIX_DEVICES}RENAME_HUB_DEVICES`;
export const RENAME_ZONE = `${PREFIX_ZONE}rename`;
export const REQUEST_DEVICES = `${PREFIX_DEVICES}REQUEST_DEVICES`;
export const RESTART_HUB = `${PREFIX_DEVICES}RESTART_HUB`;
export const RESTARTED_HUB = `${PREFIX_DEVICES}RESTARTED_HUB`;



// WEBPACK FOOTER //
// ./src/core/state/devices/constants.js